import {
  ALGOLIA_NEURAL_SEARCH_PER_TENANT_EXPERIMENT,
  EXPERIMENT_VARIATION,
} from 'shared/experiments/consts'
import { getExperiments } from 'shared/experiments/utils/experiments'
import { type Experiment } from 'types/shopConfig'

import { ALGOLIA_INDEXES_TO_EXPERIMENT } from './consts'

export const getAlgoliaNeuralSearchIndexIfEnabled = (
  experiments: Experiment[] = [],
  indexName: string
): string => {
  const experimentNames = Object.values(
    ALGOLIA_NEURAL_SEARCH_PER_TENANT_EXPERIMENT
  ).map(experiment => experiment?.desktop)

  const [neuralSearchExperiment] = getExperiments(experimentNames, experiments)

  if (
    neuralSearchExperiment?.variant === EXPERIMENT_VARIATION.V1 &&
    ALGOLIA_INDEXES_TO_EXPERIMENT[indexName]
  ) {
    return ALGOLIA_INDEXES_TO_EXPERIMENT[indexName]
  }

  return indexName
}
